import React, { Component } from 'react'
import {
  Paper,
  Button,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Typography,
} from "@material-ui/core"

import { isEqual } from 'lodash';
import LineItem from "./LineItem";
import LineItemEditable from "./LineItemEditable"

import { getCostCentres } from '../../../api/resources/CostCentres'

import * as defs from '../PurchaseOrder.module.scss'

import classnames from 'classnames';

const columnWidths = {
  description: 'auto',
  costCentre: '250px',
  quantity: '100px',
  cost: '150px',
  totalPrice: '150px',
  buttons: '168px'
}

const initLineItems = lineItems => {
  return lineItems.length > 0 ? lineItems : [{ isEditing: true, isNew: true }]
}

export default class LineItems extends Component {

  constructor(props) {
    super(props)
    this.state = {
      lineItems: [],
    }
    this.handleUpdateLineItem = this.handleUpdateLineItem.bind(this)
    this.handleCancelEdit = this.handleCancelEdit.bind(this)
    this.handleSetEditing = this.handleSetEditing.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.addNew = this.addNew.bind(this)
  }

  componentDidMount() {
    getCostCentres().then(costCentres => {
      this.setState({
        costCentres,
        lineItems: initLineItems(this.props.lineItems)
      })
    })
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.lineItems, prevProps.lineItems)) {
      this.setState({
        lineItems: initLineItems(this.props.lineItems)
      })
    }
  }

  handleUpdateLineItem(payload, idx, save) {
    let { lineItems } = this.state;
    lineItems[idx] = {...lineItems[idx], ...payload };
    lineItems = lineItems.map((lineItem, _idx) => {
      const _lineItem = {
        ...lineItem,
        received: (lineItem.received || 0),
        lineNumber: (_idx + 1)
      };
      if (idx != _idx || (idx === _idx && save)) {
        _lineItem.isEditing = false;
        _lineItem.isNew = false;
      } else {
        _lineItem.isEditing = true;
      };
      return _lineItem;
    });
    this.setState({ lineItems });
    this.props.onUpdate(lineItems, save);
  }

  addNew() {
    let { lineItems } = this.state;
    lineItems = lineItems.map(lineItem => ({...lineItem, isEditing: false}))
    const newLineItem = {
      cost: 0,
      description: null,
      quantity: null,
      costCentre: null,
      isEditing: true,
      isNew: true,
    }
    this.setState({
      lineItems: [...lineItems, newLineItem]
    })
  }

  handleCancelEdit(idx) {
    let { lineItems } = this.state;
    if (lineItems[idx].isNew) lineItems.splice(idx, 1);
    lineItems = lineItems.map(lineItem => ({...lineItem, isEditing: false}));
    this.setState({ lineItems });
    this.props.onCancelEdit();
  }

  handleSetEditing(idx) {
    let { lineItems } = this.state;
    lineItems = lineItems.map(lineItem => ({...lineItem, isEditing: false}))
    lineItems[idx].isEditing = true;
    this.setState({ lineItems })
    this.props.onStartEdit();
  }

  handleDelete(idx) {
    if (confirm('Are you sure you want to delete this line item?')) {
      let { lineItems } = this.state;
      lineItems.splice(idx, 1);
      this.setState({ lineItems })
      this.props.onUpdate(lineItems)
    }
  }

  render() {

    const { lineItems, costCentres } = this.state;
    const { isEditable, error } = this.props;
    const isEditing = lineItems.filter(li => li.isEditing).length > 0;
    return (
      <Paper style={{ margin: 16, maxWidth: '1339px'}}>
        <Typography
          className={classnames({
            [defs.lineItemsTitle]: true,
            [defs.error]: error
          })}
        >Line items{error && ` (${error})`}</Typography>
        <TableContainer>
          <Table aria-label="simple table" size='small'>
            <TableHead>
              <TableRow>
                <TableCell align="left" width={columnWidths.description}><strong>Description</strong></TableCell>
                <TableCell align="left" width={columnWidths.costCentre}><strong>Cost Centre</strong></TableCell>
                <TableCell align="right" width={columnWidths.quantity}><strong>Quantity</strong></TableCell>
                <TableCell align="right" width={columnWidths.cost}><strong>Cost per-unit</strong></TableCell>
                <TableCell align="right" width={columnWidths.totalPrice}><strong>Total</strong></TableCell>
                <TableCell align="right" width={columnWidths.buttons}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              { lineItems.map((lineItem, idx) => (
                <React.Fragment key={idx}>
                  { !lineItem.isEditing &&
                    <LineItem
                      lineItem={lineItem}
                      costCentres={costCentres}
                      editable={!isEditing && isEditable}
                      onStartEdit={() => this.handleSetEditing(idx)}
                      onDeleteItem={() => this.handleDelete(idx)}
                      columnWidths={columnWidths}
                    />
                  }
                  { lineItem.isEditing &&
                    <LineItemEditable
                      lineItem={lineItem}
                      costCentres={costCentres}
                      onUpdateLineItem={(payload, save = false) => this.handleUpdateLineItem(payload, idx, save)}
                      onCancelEdit={() => this.handleCancelEdit(idx)}
                      columnWidths={columnWidths}
                    />
                  }
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        { !isEditing && isEditable && <Button style={{margin: 16}}
          onClick={this.addNew}
          color="primary"
          variant="outlined"
        >Add new line item</Button> }
      </Paper>
    )
  }
}
